import { ReviewImageGallery } from './ReviewImageGallery'
import { StarRating } from './StarRating'

import noProfileImage from '../../assets/no_profile_image.jpg'

import { Box } from '@/components/ui/base'
import { SpaceBetween } from '@/components/ui/base'

interface ReviewDisplayProps {
  rating: number
  text: string
  images?: string[]
  reviewerName: string
  createdAt: string
  updatedAt?: string
  version?: string
  reviewerPhoto?: string
  className?: string
}

export const ReviewDisplay = ({
  rating,
  text,
  images,
  reviewerName,
  createdAt,
  updatedAt,
  version,
  reviewerPhoto,
  className = '',
}: ReviewDisplayProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  return (
    <Box
      padding="m"
      backgroundColor="background-container-content"
      borderRadius="m"
      border="1px solid #e9ebed"
      className={className}
    >
      <SpaceBetween size="s">
        {/* Header with user info and rating */}
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <SpaceBetween direction="horizontal" size="s" alignItems="center">
            <img
              src={reviewerPhoto || noProfileImage}
              alt={reviewerName || 'User'}
              style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
            />
            <Box>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{reviewerName || 'Unknown User'}</span>
              {version && (
                <Box fontSize="body-s" color="text-body-secondary">
                  Version {version}
                </Box>
              )}
            </Box>
            <StarRating value={rating} readonly size="small" />
          </SpaceBetween>
        </Box>

        {/* Review text */}
        <Box fontSize="body-m" lineHeight="body-m">
          {text}
        </Box>

        {/* Review Images */}
        {images && images.length > 0 && (
          <ReviewImageGallery images={images} reviewText={text} reviewRating={rating} reviewerName={reviewerName} />
        )}

        {/* Footer with date */}
        <Box fontSize="body-s" color="text-body-secondary">
          {formatDate(createdAt)}
          {updatedAt && updatedAt !== createdAt && <> • Edited {formatDate(updatedAt)}</>}
        </Box>
      </SpaceBetween>
    </Box>
  )
}
